import { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { Icon } from '../../icon/Icon';
import { NakedInput } from '../../inputs/NakedInput';

interface SurveyNakedInputProps {
  type: 'text' | 'number';
  label: string;
  placeholder: string;
  inputValue: string | number;
  isButton?: boolean;
  isEditable?: boolean;
  isFocus?: boolean;
  onClickHandler?: () => void;
  onChange?: (newValue: string | number | undefined) => void;
  hasBorder?: boolean;
}

export const SurveyNakedInput = ({
  type,
  label,
  placeholder,
  inputValue,
  isButton = false,
  isEditable = true,
  isFocus = false,
  onClickHandler,
  onChange,
  hasBorder = true,
}: SurveyNakedInputProps) => {
  const inputRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (isFocus) {
      inputRef.current?.focus();
    }
  }, [isFocus]);

  return (
    <Container
      hasBorder={hasBorder}
      onClick={() => {
        if (onClickHandler) {
          onClickHandler();
        }

        if (!isButton) {
          inputRef.current?.focus();
        }
      }}
    >
      <Label>{label}</Label>
      <NakedInput
        type={type}
        placeholder={placeholder}
        inputValue={inputValue}
        onChange={onChange}
        isButton={isButton}
        inputRef={inputRef}
        isEditable={isEditable}
      />
      <Icon name={'AngleRight'} width={14} height={14} fill={'#505363'} />
    </Container>
  );
};

const Container = styled.li<{ hasBorder: boolean }>`
  display: flex;
  padding: var(--radius-large, 16px) 0px;
  border-bottom: ${({ hasBorder }) =>
    hasBorder ? '1px solid var(--Light-Scheme-Monochrome-grey20, #e4e4ed)' : 'none'};

  align-items: center;
  gap: 10px;
  align-self: stretch;

  cursor: pointer;
`;

const Label = styled.span`
  color: #000;
  flex: 1 0 0;

  /* Display/Large/l-bold */
  font-family: Pretendard;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 130%; /* 20.8px */

  white-space: nowrap;
`;
